import React from "react"
import { Helmet } from "react-helmet"

export default function Head() {
  return <Helmet></Helmet>
}
